// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrivateFeed_wrapper__9vdOP","border":"PrivateFeed_border__Reo66","inset":"PrivateFeed_inset__3PjUM","title":"PrivateFeed_title__3z0Wr"};